import auditLogEntitiesSelector from "./audit-log-entities";
import auditLogsSelector from "./audit-logs";
import entitiesSelector from "./entities";
import groupsSelector from "./groups";
import permissionsSelector from "./permissions";
import policiesSelector from "./policies";
import productsSelector from "./products";
import resourceTypesSelector from "./resource-types";
import resourcesSelector from "./resources";
import rolesSelector from "./roles";
import servicesSelector from "./services";
import usersSelector from "./users";

const selectors = {
  products: productsSelector,
  services: servicesSelector,
  resourceTypes: resourceTypesSelector,
  resources: resourcesSelector,
  roles: rolesSelector,
  permissions: permissionsSelector,
  users: usersSelector,
  groups: groupsSelector,
  entities: entitiesSelector,
  policies: policiesSelector,
  auditLogs: auditLogsSelector,
  auditLogEntities: auditLogEntitiesSelector
};

export default selectors;
